import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_API_URL } from "../../consts";

// Client-scoped reference data (staff list, work sectors, working patterns,
// leave/overtime catalogs) that's fetched the same way, with the same
// clientId-only params, from many pages (Staff, UserProfile, Shifts,
// Clients, settings pages...). Each page used to fetch it independently
// with raw axios on every mount — browsing between pages re-fetched the
// same unchanged data over and over and contributed to a production
// memory crash. RTK Query caches it per clientId and shares it across
// every page that asks for the same clientId.
export const orgDataApi = createApi({
  reducerPath: "orgDataApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_API_URL }),
  // Same 30s window as financeApi: short enough that edits (add/remove a
  // user, change a work sector) show up quickly, long enough to absorb
  // rapid back-and-forth navigation between pages that all want this data.
  refetchOnMountOrArgChange: 30,
  endpoints: (builder) => ({
    getUsers: builder.query<any[], string>({
      query: (clientId) => ({ url: `/${clientId}/users` }),
    }),

    getWorkingPatterns: builder.query<any[], string>({
      query: (clientId) => ({ url: `/${clientId}/working-patterns` }),
    }),

    getWorkSectors: builder.query<any[], string>({
      query: (clientId) => ({ url: `/admin/${clientId}/getWorkSectors` }),
    }),

    getClientLeaves: builder.query<any[], string>({
      query: (clientId) => ({ url: `/admin/${clientId}/leaves` }),
    }),

    getClientOvertimes: builder.query<any[], string>({
      query: (clientId) => ({ url: `/admin/${clientId}/overtimes` }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetWorkingPatternsQuery,
  useGetWorkSectorsQuery,
  useGetClientLeavesQuery,
  useGetClientOvertimesQuery,
} = orgDataApi;
